module.exports = __webpack_public_path__ + "media/images/salle de bain-8ad5cc147f464348bda4623f375a0a19.svg";